var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({class:_vm.badgeClass},'div',_vm.$attrs,false),_vm.$listeners),[(_vm.$slots.icon)?_c('span',{class:_vm.iconClass},[_vm._t("icon")],2):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }